export const invoicesEndpoints = {
  getStoreInvoices: 'getStoreInvoices',
  getTaxRules: 'getTaxRules',
  createArTaxRules: 'createArTaxRules',
  getArTaxRules: 'getArTaxRules',
  updateArTaxRules: 'updateArTaxRules',
  deleteArTaxRules: 'deleteArTaxRules',
} as const;

export const invoicesTags = {
  storeInvoices: 'storeInvoices',
  taxRules: 'taxRules',
  arTaxRules: 'arTaxRules',
} as const;

export const GET_STORE_INVOICES_URL = '/v1/invoices/store';
export const GET_TAX_RULES_URL = '/v1/invoices/tax-rules';
export const CREATE_AR_TAX_RULES_URL = '/v1/invoices/ar/tax-rules';
export const GET_AR_TAX_RULES_URL = '/v1/invoices/ar/tax-rules';
export const UPDATE_AR_TAX_RULES_URL = '/v1/invoices/ar/tax-rules/:id';
export const DELETE_AR_TAX_RULES_URL = '/v1/invoices/ar/tax-rules/:id';
